<template>
  <v-btn
    color="primary"
    :loading="loading"
    @click="update()"
  >
    <v-icon>
      mdi-update
    </v-icon>
    Atualizar
  </v-btn>
</template>

<script>
export default {
  name: 'UpdateReportListBtn',
  data: () => ({
    loading: '',
    listName: 'ReportsList',
  }),
  created() {
    this.handleLoading();
  },
  methods: {
    update() {
      this.$root.$emit(`refresh-crud-${this.listName}`, {});
    },
    handleLoading() {
      this.$root.$on(`loading-crud-${this.listName}`, (bool) => {
        if (typeof bool === 'boolean') this.loading = bool;
      });
    },
  },
};
</script>
